// extracted by mini-css-extract-plugin
var _1 = "D6KEYC";
var _2 = "TzBrF9";
export { _1 as "modified", _2 as "terms" }
